{
	"plantNameTitle": "Plant name",
	"plantIdTitle": "Plant ID",
	"countryTitle": "Country",
	"detailsTitle": "Details",
	"fetchError": "Could not load the plants. Please try again."
}
